module.exports = __webpack_public_path__ + "img/logo.1ec8bda2.png";